import styled from 'styled-components';

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  span {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.grey1};
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  span {
    font-weight: 700;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.tertiary};
    white-space: nowrap;
  }

  svg {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;

export const SubscriptionContainer = styled.div`
  position: relative;

  padding-left: 120px;

  background: ${({ theme }) => theme.colors.white};
  border-radius: 16px;

  margin-top: 28px;

  img {
    position: absolute;
    width: 151px;
    height: 258px;
    top: -20px;
    left: -50px;
  }
`;

export const SubscriptionContent = styled.div`
  padding: 24px 12px 24px 0px;

  h1 {
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.grey1};
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-top: 8px;

  width: fit-content;
  margin-right: auto;
`;

export const PriceItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  border-radius: 4px;

  background: ${({ theme }) => theme.colors.grey4};

  overflow: hidden;
`;

export const TotalPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .discountSection {
    background: ${({ theme }) => theme.colors.darkBlue3};

    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;

    gap: 8px;

    padding-left: 8px;

    span {
      font-weight: 700;
      font-size: 10px;
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .priceSection {
    border: 1px solid ${({ theme }) => theme.colors.darkBlue3};
    border-radius: 8px;
    padding: 8px;

    background: ${({ theme }) => theme.colors.white};

    span {
      font-weight: 700;
      font-size: 13px;
      color: ${({ theme }) => theme.colors.darkBlue3};
      white-space: nowrap;
    }
  }
`;

export const MonthPriceWrapper = styled.div`
  height: 100%;

  width: 100%;

  margin-left: 8px;
  margin-right: 4px;

  span {
    white-space: nowrap;
    text-align: center;
    fonts-size: 15px;
    color: ${({ theme }) => theme.colors.grey1};
    font-weight: 600;

    .additionalPrice {
      font-weight: 400;
    }
  }
`;

export const TextContainer = styled.div`
  margin-bottom: 24px;

  p {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.grey1};
    line-height: 19.5px;
  }

  p span {
    font-weight: 600;
  }
`;

export const LineSeparator = styled.div`
  height: 1px;
  width: 100%;

  margin: 16px 0;

  margin-left: auto;

  border: 1px solid ${({ theme }) => theme.colors.darkBlue3};
`;

export const WarningContainer = styled.div`
  p {
    font-weight: 500;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.grey1};
    line-height: 13px;
  }

  p span {
    font-weight: 700;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;

  > div:first-of-type {
    margin-bottom: 24px;
  }

  width: 100%;

  margin-top: 24px;
  margin-left: auto;

  p {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.grey1};
    margin-bottom: 16px;
  }
`;

export const PaymentOptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 27px;

  max-height: 73px;

  border: 1px solid ${({ theme }) => theme.colors.grey6};

  border-radius: 8px;

  cursor: pointer;

  background: ${({ theme }) => theme.colors.white};
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;

  align-items: center;

  span {
    font-weight: 600;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey1};
  }
`;

export const ActionContainer = styled.div`
  padding: 2px 13px;
  background: #2eb3de;

  border-radius: 15px;

  span {
    font-weight: 600;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.white};
  }
`;
